import {ArrayTools} from '@selpia/shared/utils';
import {Measure} from '@selpia/shared/models';


export class MeasuresHelper {
  static getAllForCodes(codes: string[], allMeasures: Measure[]): Measure[] {
    return ArrayTools.removeFalsy(codes.map((code) => {
      try {
        return this.getForCode(code, allMeasures);
      } catch (error) {
        console.error(error);
        return;
      }
    }));
  }

  static getAllForCodesOrNull(codes: string[], allMeasures: Measure[]): Array<Measure | null> {
    return codes.map((code) => {
      if (!code) {
        return null;
      }
      try {
        return this.getForCode(code, allMeasures) || null;
      } catch (error) {
        console.error(error);
      }
      return null;
    });
  }

  static getForCode(code: string, allMeasures: Measure[]): Measure {
    const measure = allMeasures.find((measure) => measure.code === code);
    if (!measure) {
      throw new Error(`Failed to find Measure for MeasureCode: ${code}`);
    }
    return measure;
  }
}
